import auth from "@/middleware/auth";
import admin from "@/middleware/admin";

export const controlStatusRoutes = [
  {
    path: "/directories/control-status",
    name: "ControlStatusList",
    meta: { middleware: [auth, admin] },
    component: () =>
      import(/* webpackChunkName: "controlStatus" */ "./components/List"),
  },
];
